import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadInfoTabs = () => {
  return getData(`${getConfig('infoTabsUrl')}`);
};
